<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableRelationalDatabaseServiceResourceAzureListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableRelationalDatabaseServiceResourceAzureVue = {};
export default {
  name: "TableRelationalDatabaseServiceResourceAzure",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.Azure.database.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.Azure.database.subscriptionName"),
          key: "subscriptionName"
        },
        {
          title: this.$t("RAM.Azure.database.subscriptionID"),
          key: "subscriptionId"
        },
        {
          title: this.$t("RAM.Azure.database.resourceGroup"),
          key: "resourceGroup"
        },
        {
          title: this.$t("RAM.Azure.database.databaseName"),
          key: "databaseName"
        },
        {
          title: this.$t("RAM.Azure.database.serverName"),
          key: "serverName"
        },
        {
          title: this.$t("RAM.Azure.database.location"),
          key: "location"
        },
        {
          title: this.$t("RAM.Azure.database.status"),
          key: "stateName"
        },
        {
          title: this.$t("RAM.Azure.database.pricingLevel"),
          key: "pricingTier"
        },
        {
          title: this.$t("RAM.Azure.database.connectionString"),
          key: "connectionStrings"
        }
      ],
      tableRelationalDatabaseServiceResourceAzureListData: []
    };
  },
  beforeCreate: function() {
    tableRelationalDatabaseServiceResourceAzureVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(accountNameSearchIDVal) {
      tableRelationalDatabaseServiceResourceAzureVue.accountNameSearchIDVal = accountNameSearchIDVal;
    });
    eventBus.$on("companyId", function(val) {
      tableRelationalDatabaseServiceResourceAzureVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableRelationalDatabaseServiceResourceAzureVue.getRelationalDatabaseServiceResourceAzureListData();
    },
    // 分页显示数据
    /****************************************************/
    getRelationalDatabaseServiceResourceAzureListData: function() {
      this.$api.resourceManagement
        .queryPagingAzureDatabaseConfig({
          accountName:
            tableRelationalDatabaseServiceResourceAzureVue.accountNameSearchIDVal,
          companyId: tableRelationalDatabaseServiceResourceAzureVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableRelationalDatabaseServiceResourceAzureListData =
            res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableRelationalDatabaseServiceResourceAzureVue.getRelationalDatabaseServiceResourceAzureListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableRelationalDatabaseServiceResourceAzureVue.getRelationalDatabaseServiceResourceAzureListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/azure/rds/TableRelationalDatabaseServiceResourceAzure.vue